import '../styles/tailwind.css'
import 'react-toastify/dist/ReactToastify.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { ToastContainer } from 'react-toastify'
import { Provider as UrqlProvider } from 'urql'
import { client } from 'app/lib/urqlClient'
import { ROUTER_FUTURE } from 'app/lib/routerFuture'
import { ConfirmationServiceProvider } from 'app/components/ConfirmationContext'
import ImageCropProvider from 'app/components/shared/image-crop/ImageCropProvider'
import { RootStore } from 'app/stores/RootStore'
import { StoreContext } from 'app/stores/StoreContext'
import { App } from './App'

const rootStore = new RootStore(client)

async function renderApp() {
  if (__INTEGRATION_TEST__) {
    const { startIntegrationWorker } = await import('app/integration/browser')
    await startIntegrationWorker()
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <UrqlProvider value={client}>
        <StoreContext.Provider value={rootStore}>
          <BrowserRouter future={ROUTER_FUTURE}>
            <DndProvider backend={HTML5Backend}>
              <ConfirmationServiceProvider>
                <ImageCropProvider>
                  <App />
                  <ToastContainer className="!z-50" />
                </ImageCropProvider>
              </ConfirmationServiceProvider>
            </DndProvider>
          </BrowserRouter>
        </StoreContext.Provider>
      </UrqlProvider>
    </StrictMode>,
  )
}

renderApp().catch((error) => {
  setTimeout(() => {
    throw error
  })
})
